// Central API/WebSocket endpoint resolution.
// - Local development (npm start): backend on localhost:8000.
// - Production build (served from the hosting subdomain): SAME-ORIGIN relative
//   URLs — the web server proxies /api and /ws through to the engine, and the
//   WebSocket scheme follows the page (https -> wss). Hardcoded localhost URLs
//   here were why a deployed build could never reach the backend.
// - REACT_APP_API_URL at build time overrides both (engine on another host).
// (auto-deploy pipeline verified live)
// deploys to Oracle VM on commit
const explicit = process.env.REACT_APP_API_URL;
const isDev = process.env.NODE_ENV === 'development';

export const API_BASE_URL = explicit || (isDev ? 'http://localhost:8000' : '');

export function wsUrl(path) {
  if (API_BASE_URL) {
    return API_BASE_URL.replace(/^http/, 'ws') + path;
  }
  const proto = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
  return `${proto}//${window.location.host}${path}`;
}
